enum CredentialsWorkflowCodeEnum {
    AUTHORIZATION = "AUTHORIZATION",
    FINISH_IDENTITY_VERIFICATION = "FINISH_IDENTITY_VERIFICATION",
    REGISTRATION = "REGISTRATION",
    START_IDENTITY_VERIFICATION = "START_IDENTITY_VERIFICATION"
}

export default CredentialsWorkflowCodeEnum;
